import MenuStyle from './Menu.style';
import { NavLink, NavbarBrand } from 'Component';
import { Link } from 'react-router-dom';
import { linkHandler } from 'utils/linkHandler';

export const Menu = ({ children, ...props }) => {
  return (
    <MenuStyle
      brandLink={
        <NavbarBrand
          tag={() => (
            <NavLink className="navbar-brand p-0" tag={Link} to={linkHandler.get('home')}>
              Balloon Home
            </NavLink>
          )}
          to={'#home'}
        />
      }
      {...props}
    >
      {children}
    </MenuStyle>
  );
};
